"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestBinanceClient = exports.orderIdParser = void 0;
const axios_1 = __importDefault(require("axios"));
// parse long numeric values
const orderIdParser = (order, index, customParsed) => {
    var _a, _b;
    return Object.assign(Object.assign({}, order), { orderId: customParsed ? (((_b = (_a = customParsed[index]) === null || _a === void 0 ? void 0 : _a.orderId) === null || _b === void 0 ? void 0 : _b.value) || '') : '' });
};
exports.orderIdParser = orderIdParser;
const PARAMS_FOR_SIGNATURE = ['timestamp', 'recvWindow', 'signature'];
class RestBinanceClient {
    setBinanceAuth(params) {
        this.signRequest = params.signRequest;
        this.axiosServicePrivate.interceptors.request.clear();
        this.axiosServicePrivate.interceptors.request.use(this.binanceAuthInterceptor);
    }
    constructor(params) {
        // TODO: add api key refresh
        this.binanceAuthInterceptor = (config) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!this.signRequest)
                return config;
            try {
                const { url } = config;
                const query = new URLSearchParams(config.params);
                const res = yield this.signRequest({
                    queryString: query.toString() || '',
                    requestBody: (_a = config.data) === null || _a === void 0 ? void 0 : _a.toString(),
                    requestMethod: config.method || 'GET',
                    requestPath: url || '',
                });
                config.headers = (_b = config.headers) !== null && _b !== void 0 ? _b : {};
                Object.entries(res.data.headers).forEach(([key, value]) => {
                    config.headers[key] = value;
                });
                config.params = (_c = config.params) !== null && _c !== void 0 ? _c : {};
                PARAMS_FOR_SIGNATURE.forEach((key) => {
                    config.params[key] = res.data.parameters[key];
                });
                Object.entries(res.data.parameters).forEach(([key, value]) => {
                    config.params[key] = value;
                });
            }
            catch (e) {
                const controller = new AbortController();
                controller.abort();
                return Object.assign(Object.assign({}, config), { signal: controller.signal });
            }
            return config;
        });
        const { axiosPublicConfig, axiosPrivateConfig, interceptorsConfig, logoutInterceptor } = params;
        this.axiosServicePublic = axios_1.default.create(axiosPublicConfig);
        this.axiosServicePrivate = axios_1.default.create(axiosPrivateConfig);
        this.axiosServicePrivate.interceptors.response.use(undefined, logoutInterceptor);
        if (interceptorsConfig)
            this.setBinanceAuth(interceptorsConfig);
    }
    static load(params) { }
}
exports.RestBinanceClient = RestBinanceClient;
